document.addEventListener('DOMContentLoaded', function() {
	let mapCareer = document.getElementById('new-map-careers-svg');

	if(mapCareer) {
		[].slice.call(mapCareer.querySelectorAll('[data-modal]')).forEach(function(pin) {
			// Get Modal
			let pinModal = document.querySelector('div[data-pin="'+pin.dataset.modal+'"]');

			if(pinModal) {
				// Get Map Pin Postion
				let pinPosition = pin.getBBox();

				// Get Coordinates for Modal
				let pinLeft = pinPosition.width*2 + parseInt(pinPosition.x);
				let pinTop = pinPosition.height + parseInt(pinPosition.y);

				// Get Style attributes for Modal
				let modalStyle = pinModal.style;

				// Set position for modal
				modalStyle.left = pinLeft+'px';

				if(pinTop > 380) {
					pinTop = pinTop - 316;
				}

				modalStyle.top = pinTop+'px';

				pin.addEventListener('click', function(event) {
					// Remove active
					let activeModal = document.querySelector('.map-modal.active');

					if(activeModal) {
						activeModal.classList.remove('active');
					}
					
					pinModal.classList.toggle('active');
				});
			}
		});

		[].slice.call(document.querySelectorAll('.close-modal')).forEach(function(closeButton) {
			closeButton.addEventListener('click', function() {
				document.querySelector('.map-modal.active').classList.remove('active');
			});
		});
	}
});